import { render, staticRenderFns } from "./embed-options.vue?vue&type=template&id=4c22b9ae&scoped=true&"
import script from "./embed-options.vue?vue&type=script&lang=js&"
export * from "./embed-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22b9ae",
  null
  
)

export default component.exports